<template>
    <div class="section-category section-full">
      <div class="btns-footer">
        <button class="btn btn-btn" @click="handleConfirm" v-translate>Print for the Location</button>
        <button class="btn btn-btn" @click="handleConfirm" v-translate>Print for '{{ user.station.name }} {{ user.shift.id }}'</button>
      </div>
      <MonthReport ref="monthReport"/>
    </div>
  </template>
  
  <script>
  import { mapState, mapGetters } from 'vuex';
  import DayService from '@/services/DayService';
  import ShiftService from '@/services/ShiftService';
  import {
    UPDATE_SHIFT, SET_SHIFT_CURRENT_ACTION, SET_MESSAGE_MODAL, SET_CONFIRM_MODAL,
  } from '@/store/mutation-types';
  import MonthReport from '@/components/MonthReport';
  
  export default {
    name: 'PrintArticleWorkday',
    components: {
      MonthReport,
    },
    data() {
      return {
        summary: null,
      };
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
        bill: state => state.bill,
        workDay: state => state.auth.user.workDay,
      }),
    },
    methods: {
      handleConfirm() {
        this.$store.commit(SET_CONFIRM_MODAL, {
          action: this.$gettext('end work day'),
          context: this,
          func: this.endDay,
        });
      },
      async endDay() {
        const report = await this.$store.dispatch(
          'createPdf',
          {
            element: document
              .getElementById('shift-report-printable-area'),
            reportType: 'workDay',
            startTime: this.user.workDay.startTime,
          },
        );
  
        const data = await DayService.endDay({
                                pdf: report.file,
                                message: report.message,
                                fileName: report.name
                              });
  
        if(data) {
          if(data['error']) {
            if(data['error'] == 'The optimistic lock on an entity failed.') {
              this.$store.commit(SET_MESSAGE_MODAL, 'An end of day operation is running.');
              return;
            }
            this.$store.commit(SET_MESSAGE_MODAL, data['error']);
            return;
          }
          await this.$store.dispatch('print', data);
          await report.pdf.save(report.name, { returnPromise: true });
          await this.$refs.monthReport.getMonthReport();
          this.$store.state.auth.user.workDay = null;
          localStorage.setItem('pos_user', JSON.stringify(this.$store.state.auth.user));
          this.$router.push({name: 'order'});
          const self = this;
          setTimeout(function() {
            self.$store.dispatch('logout');
          }, 180000);
        }
      },
    },
    async created() {
      if(!this.user.workDay) this.$router.push({ name: 'order' });
      const response = await DayService.infoDay();
      if (response) {
        this.summary = response;
        this.tablePayment = [
          {
            name: this.$gettext('Money-in'),
            payments: this.summary.moneyIns,
            total: this.summary.moneyIns.reduce((sum, payment) => sum + payment.amount, 0),
            open: true
          },
          {
            name: this.$gettext('Money-out'),
            payments: this.summary.moneyOuts,
            total: this.summary.moneyOuts.reduce((sum, payment) => sum + payment.amount, 0),
            open: true
          },
        ];
        this.tableCommission = [
          {
            name: this.$gettext('Earned Commission'),
            payments: this.summary.commissionList,
            total: this.summary.commissionList.reduce((sum, payment) => sum + payment.amount, 0),
            open: true
          },
          {
            name: this.$gettext('Paid Commission'),
            payments: this.summary.payCommissions,
            total: this.summary.payCommissions.reduce((sum, payment) => sum + payment.amount, 0),
            open: true
          },
        ];
      }
    },
  };
  </script>
  
  <style scoped>
  tr.border-top.border-bottom td {
    color: #F00;
  }
  </style>
  